<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <div>
          <form-summary />
        </div>

        <b-field class="mb-0">
          <p class="control">
            <a
              :href="helpImageUrl('團費說明.png')"
              @click.prevent="onClickImage(helpImageUrl('團費說明.png'))"
              style="margin-left: 1rem;"
            >
              <img
                :src="helpImageUrl('團費說明.png')"
                alt="團費說明"
                width="56"
              />
            </a>
          </p>

          <b-button
            disabled="disabled"
            :loading="sending"
            type="is-primary"
            native-type="submit"
            style="width: 240px; position: absolute; top: 10px; right: 10px;"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>

        <b-tabs v-model="activeTab" :animated="false" type="is-box">
          <b-tab-item>
            <template #header>
              <span>團費包含</span>
              <b-tooltip type="is-dark" position="is-right" label="適用新網站">
                <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
            </template>

            <form-group name="price_remark1" attribute="團費包含">
              <editor
                ref="price_remark1_editor"
                v-model="form.price_remark1"
                :area="travelGroup.image_path"
                :height="editorHeight"
              ></editor>
            </form-group>
          </b-tab-item>

          <b-tab-item>
            <template #header>
              <span>團費不含</span>
              <b-tooltip type="is-dark" position="is-right" label="適用新網站">
                <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
            </template>

            <form-group name="price_remark2" attribute="團費不含">
              <editor
                ref="price_remark2_editor"
                v-model="form.price_remark2"
                :area="travelGroup.image_path"
                :height="editorHeight"
              ></editor>
            </form-group>
          </b-tab-item>

          <b-tab-item>
            <template #header>
              <span>費用說明</span>
              <b-tooltip type="is-dark" position="is-right" label="適用新網站">
                <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
            </template>

            <form-group name="price_remark3" attribute="費用說明">
              <editor
                ref="price_remark3_editor"
                v-model="form.price_remark3"
                :area="travelGroup.image_path"
                :height="editorHeight"
              ></editor>
            </form-group>
          </b-tab-item>
        </b-tabs>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators'
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'TravelGroupCostDescForm',
  components: { Editor },

  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,
      form: this.extractFormValues(this.travelGroup),

      activeTab: 0,

      isImageModalActive: false,
      selectedImageUrl: null,

      windowHeight: window.innerHeight
    }
  },
  computed: {
    editorHeight() {
      return this.windowHeight - 402
    }
  },
  validations: {
    form: {
      price_remark1: { maxLength: maxLength(1000) },
      price_remark2: { maxLength: maxLength(1000) },
      price_remark3: { maxLength: maxLength(2000) }
    }
  },
  watch: {
    travelGroup(newGroup) {
      this.form = this.extractFormValues(newGroup)
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    extractFormValues(data) {
      return {
        price_remark1: data.price_remark1 || '',
        price_remark2: data.price_remark2 || '',
        price_remark3: data.price_remark3 || ''
      }
    },
    async onSend() {
      this.form.price_remark1 = this.$refs.price_remark1_editor.getData()
      this.form.price_remark2 = this.$refs.price_remark2_editor.getData()
      this.form.price_remark3 = this.$refs.price_remark3_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      try {
        const api = `${TRAVEL_GROUPS_API}/${this.travelGroup.code}/cost-desc`

        this.sending = true
        const res = await this.axios.put(api, this.form)
        this.$emit('updated', res.data.data)
        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    onResize() {
      this.windowHeight = window.innerHeight
    }
  }
}
</script>
